import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Stack,
} from "@chakra-ui/react";

export default function UpgradeToProModal({ isOpen, onClose, onUpgrade }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Upgrade to Pro</ModalHeader>
        <ModalBody>
          <Stack spacing={3}>
            <Text>
              Unlock full QR Analytics, including impressions, scans, conversion
              rates, and slot‑level performance insights.
            </Text>
            <Text fontWeight="bold">£19/month</Text>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" onClick={onUpgrade}>
            Upgrade Now
          </Button>
          <Button ml={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
